export default class Color {
    colorId: number
    userId: number
    rgb: number

    constructor( colorId: number, userId: number, rgb: number ) {
        this.colorId = colorId;
        this.userId = userId;
        this.rgb = rgb;
    }

}